import { lazy, Suspense, useEffect } from 'react';
import Index from './jsx/index';
import { connect, useDispatch } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import { ToastContainer } from 'react-toastify';
import { startHeartbeat } from './services/providerStatusService';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import 'react-toastify/dist/ReactToastify.css';
import './i18n';

const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});
const Help = lazy(() => import('./jsx/pages/Help'));

function App(props) {
    const dispatch = useDispatch();
    
    // Obtenir l'utilisateur actuel et le token d'authentification depuis Redux
    const providerId = props.providerId || 0;
    const authToken = props.authToken || localStorage.getItem('token') || '';

    useEffect(() => {
        checkAutoLogin(dispatch, props.history);
    }, [dispatch, props.history]);

    // Hook pour démarrer le heartbeat pour les prestataires
    useEffect(() => {
        if (props.isAuthenticated) {
            const cleanup = startHeartbeat(providerId, authToken);
            return cleanup;
        }
    }, [props.isAuthenticated, providerId, authToken]);

    let routes = (
        <Switch>
            <Route path='/login' component={Login} />
            <Route path='/page-register' component={SignUp} />
            <Route path='/page-forgot-password' component={ForgotPassword} />
            <Route path='/help' component={Help} />
        </Switch>
    );

    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }>
                    <Index />
                    <ToastContainer
                        position='top-right'
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Suspense>
            </>
        );
    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }>
                    {routes}
                </Suspense>
                <ToastContainer
                    position='top-right'
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    
    return {
        isAuthenticated: isAuthenticated(state),
        providerId: state.auth.auth.providerId, 
        authToken: state.auth.auth.token, 
    };
};

export default withRouter(connect(mapStateToProps)(App));